import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  user: null,
  verifyingOtp: false,
  otpVerified: false,
  forgotPasswordInProgress: false,
  resetPasswordInProgress: false,
  loading: false,
  error: null,
  message: null,
  profile: null, // user profile image
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        error: null,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: true,
        user: action.payload,
      };
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
        error: action.payload,
      };
    case actionTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        verifyingOtp: true,
        error: null,
      };
    case actionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        verifyingOtp: false,
        otpVerified: true,
      };
    case actionTypes.VERIFY_OTP_FAILURE:
      return {
        ...state,
        verifyingOtp: false,
        error: action.payload,
      };
    case actionTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordInProgress: true,
        error: null,
      };
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordInProgress: false,
      };
    case actionTypes.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordInProgress: false,
        error: action.payload,
      };
    case actionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordInProgress: true,
        error: null,
      };
    case actionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordInProgress: false,
      };
    case actionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordInProgress: false,
        error: action.payload,
      };
    case actionTypes.USER_PROFILE_UPLOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.USER_PROFILE_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.USER_PROFILE_UPLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.USER_PROFILE_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.USER_PROFILE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
        profile: null,
      };
    case actionTypes.USER_PROFILE_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.USER_PROFILE_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.USER_PROFILE_FETCH_SUCCESS:
      return { ...state, loading: false, profile: action.payload };

    case actionTypes.USER_PROFILE_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actionTypes.USER_CREATE_REQUEST:
    case actionTypes.USER_GET_REQUEST:
    case actionTypes.USER_UPDATE_REQUEST:
    case actionTypes.USER_DELETE_REQUEST:
    case actionTypes.USER_RESENTMAIL_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.USER_CREATE_SUCCESS:
    case actionTypes.USER_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        auth: action.payload,
      }
    case actionTypes.USER_UPDATE_SUCCESS:
    case actionTypes.USER_DELETE_SUCCESS:
    case actionTypes.USER_RESENTMAIL_SUCCESS:

      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.USER_CREATE_FAILURE:
    case actionTypes.USER_GET_FAILURE:
    case actionTypes.USER_UPDATE_FAILURE:
    case actionTypes.USER_DELETE_FAILURE:
    case actionTypes.USER_RESENTMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export default authReducer;
